import _ from 'lodash';
import React from 'react';
import { toast } from 'react-toastify';

import { Auth0Metadata } from '../../api/API';
import { history } from '../../util/History';
import { Auth0Context, useAuth0 } from '../Auth0Provider';
import { Role } from '../PrivateRoute';

export type HomeProps = {
  // inputs
  /** user is logged */
  isAuthenticated: boolean;
  /** request in flight */
  isLoading: boolean;
  // outputs
  login: () => void;
  logout: () => void;
};

export const homeContainer = (LoginScreen: React.ComponentType<HomeProps>) => () => {
  const { isAuthenticated, isLoading, loginWithRedirect, logout, user } = useAuth0() as Auth0Context;

  // handler for login errors
  React.useEffect(() => {
    if (window.location.search) {
      const url = new URL(window.location.href);
      const error = url.searchParams.get('error_description');
      if (error) {
        toast.error(_.capitalize(error));
        history.push('/');
      }
    }
  }, [window.location.search]);

  React.useEffect(() => {
    if (isAuthenticated && user) {
      const roles = user?.[Auth0Metadata.Roles];
      if (!roles.length) return;

      const isAdmin = Boolean([Role.Admin].find(allowedRole => roles.includes(allowedRole)));
      if (isAdmin) {
        history.push('/overall-student-list');
      } else {
        history.push('/academic-overview');
      }
    }
  }, [isAuthenticated, user]);

  return (
    <LoginScreen
      isAuthenticated={isAuthenticated}
      isLoading={isLoading}
      login={() => loginWithRedirect({})}
      logout={() => {
        logout({ returnTo: window.location.origin });
      }}
    />
  );
};
